var __default__ = {
  middleware: ['prevent-step-skipping']
};
import { useFormStore } from '../stores/form';
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'default',
  setup: function setup(__props) {
    var store = useFormStore();
    var route = useRoute();
    onMounted(function () {
      var _route$query;
      validateCampaignQuery(route.query.campaign);
      store.referral = (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.referral;
    });
    var isFramed = computed(function () {
      return window.top !== window.self;
    });
    function validateCampaignQuery(campaign) {
      if (campaign && campaign.length < 128) {
        store.campaign = campaign;
      }
    }
    return {
      __sfc: true,
      store: store,
      route: route,
      isFramed: isFramed,
      validateCampaignQuery: validateCampaignQuery
    };
  }
});